import React, { useRef, useEffect } from 'react';

const Trunk = props => {
    return (
        <>
          <div className='truckMovData' style={{position:'absolute',top:'0'}}>
            <span className='amnbIn'>{parseFloat(props.truckCountData.sbIn).toFixed(1)}</span>
            <span className='amnbEx'>{parseFloat(props.truckCountData.sbEx).toFixed(1)}</span>
            <span className='amsbIn'>{parseFloat(props.truckCountData.nbIn).toFixed(1)}</span>
            <span className='amsbEx'>{parseFloat(props.truckCountData.nbEx).toFixed(1)}</span>
            <span className='amebIn'>{parseFloat(props.truckCountData.wbIn).toFixed(1)}</span>
            <span className='amebEx'>{parseFloat(props.truckCountData.wbEx).toFixed(1)}</span>
            <span className='amwbIn'>{parseFloat(props.truckCountData.ebIn).toFixed(1)}</span>
            <span className='amwbEx'>{parseFloat(props.truckCountData.ebEx).toFixed(1)}</span>
            <span className='amNbLeft'>{parseFloat(props.truckCountData.sbLeft).toFixed(1)}</span>
            <span className='amSbLeft'>{parseFloat(props.truckCountData.nbLeft).toFixed(1)}</span>
            <span className='amEbLeft'>{parseFloat(props.truckCountData.wbLeft).toFixed(1)}</span>
            <span className='amWbLeft'>{parseFloat(props.truckCountData.ebLeft).toFixed(1)}</span>
            <span className='amNbRight'>{parseFloat(props.truckCountData.sbRight).toFixed(1)}</span>
            <span className='amSbRight'>{parseFloat(props.truckCountData.nbRight).toFixed(1)}</span>
            <span className='amEbRight'>{parseFloat(props.truckCountData.wbRight).toFixed(1)}</span>
            <span className='amWbRight'>{parseFloat(props.truckCountData.ebRight).toFixed(1)}</span>                          
            <span className='amNbMiddle'>{parseFloat(props.truckCountData.sbMiddle).toFixed(1)}</span>
            <span className='amSbMiddle'>{parseFloat(props.truckCountData.nbMiddle).toFixed(1)}</span>
            <span className='amEbMiddle'>{parseFloat(props.truckCountData.wbMiddle).toFixed(1)}</span>
            <span className='amWbMiddle'>{parseFloat(props.truckCountData.ebMiddle).toFixed(1)}</span>
            <span className='nUturn'>{parseFloat(props.truckCountData.suturn).toFixed(1)}</span>
            <span className='sUturn'>{parseFloat(props.truckCountData.nuturn).toFixed(1)}</span>
            <span className='eUturn'>{parseFloat(props.truckCountData.wsuturn).toFixed(1)}</span>
            <span className='wUturn'>{parseFloat(props.truckCountData.euturn).toFixed(1)}</span>
          </div>
        </>
      )
}
export default Trunk;